import { useHistory } from "react-router-dom";
import { TextArea, Button, Dropdown } from "semantic-ui-react";
import { useEffect, useState } from "react";
import Popup from "reactjs-popup";

import { db } from "../../../../../config/firebase";
import ArrowDownDropDownIcon from "../../../../../assets/images/incident/arrowdowndrop.svg";
import Category_Question from "../../../../../assets/images/incident/category_question.svg";
import CategoryChecked from "../../../../../assets/images/incident/category_checked.svg";
import CategoryOne from "../../../../../assets/images/incident/category1.svg";
import CategoryTwo from "../../../../../assets/images/incident/category2.svg";
import CategoryThree from "../../../../../assets/images/incident/category3.svg";
import CategoryFour from "../../../../../assets/images/incident/category4.svg";
import ExitIcon from "../../../../../assets/images/incident/exit.svg";

import DraftFooter from "../../../../../components/DraftFooter";
import PendingApprovalFooter from "../../../../../components/PendingApprovalFooter";
import PendingRejectFooter from "../../../../../components/PendingRejectFooter";
import ReopenFooter from "../../../../../components/ReopenFooter";
import ClosedFooter from "../../../../../components/ClosedFooter";


const HS = (props) => {

    const [controllabilityClassification, setControllabilityClassification] = useState([]);
    const [typeOfIncidentMOM, setTypeOfIncidentMOM] = useState([]);

    let history = useHistory();

    let filterP4 = props.AuthDetail.perms && props.AuthDetail.perms.some((p) => p == "p4");
    let filterP4A = props.AuthDetail.perms && props.AuthDetail.perms.some((p) => p == "p4a");
    let filterP5 = props.AuthDetail.perms && props.AuthDetail.perms.some((p) => p == "p5");

    let categoryOptions = [
        {
        value: "c1",
        image: CategoryOne,
        },
        {
        value: "c2",
        image: CategoryTwo,
        },
        {
        value: "c3",
        image: CategoryThree,
        },
        {
        value: "c4",
        image: CategoryFour,
        },
    ];

    let categoriesLevel = [
        {
            cat: "CAT",
            num: 1,
            subTitle: "Minor",

            status: "Injury or Ill-health requiring First-Aid Only",
            impact: "Minor impact to services and/or business operations",
            affected: "up to S$100k",
            reputation: "Minor complains from any party",
        },
        {
            cat: "CAT",
            num: 2,
            subTitle: "Moderate",

            status:
                "Serious injury requiring medical treatment or ill health leading to disability",
            impact: "short term impact to services and/or business operationss",
            affected: "S$100k to S$1m",
            reputation: "Adverse but low key media",
        },
        {
            cat: "CAT",
            num: 3,
            subTitle: "Moderate",

            status:
                "Fatality, serious injuries, or major outbreak or life threatening diseases",
            impact: "Extended disruptions to services and/or business operations",
            affected: "S$1m to S$5m",
            reputation: "Adverse media attention",
        },
        {
            cat: "CAT",
            num: 4,
            subTitle: "Catastrophic",

            status: "Multiple Fatality",
            impact:
                "Disastrous  and uncontrolled disruptions to services and/or business operations",
            affected: "More than S$5m",
            reputation: "Prolong adverse media attention",
        },
    ];

    const values = props.HSValues
    const overview_values = props.overViewValues;
    const incidentStatus = props.incidentStatus;

    const onChangeHSAction = props.onChangeHSAction;

    const {
        ccError,
        cscError,
        categoryError,
        typeOfIncidentMOMError,
    } = props.HSError;

    useEffect(() => {
        db.collection("static_data")
            .doc("controllability_classification")
            .get()
            .then((querySnapshot) => {
                let data = [];
                querySnapshot.data().controllability_classification_arr.forEach((doc, index) => {
                    data.push({
                    key: doc,
                    text: doc,
                    value: doc,
                    });
                });
        
                setControllabilityClassification(data);
            });

        db.collection("static_data")
            .doc("type_of_incident_for_mom")
            .get()
            .then((querySnapshot) => {
                let data = [];
                querySnapshot.data().type_of_incident_for_mom_arr.forEach((doc, index) => {
                    data.push({
                    key: doc,
                    text: doc,
                    value: doc,
                    });
                });
        
                setTypeOfIncidentMOM(data);
            });
    }, []);

    const checkPreviousValueAndCurrent = (previous, current, key) => {
        let splitUnderScore = key.replaceAll("_", " ");
        if (previous != current) {
            props.onListenValueChange(
            key,
            `Update ${splitUnderScore}  from ${previous} to ${current}`
            );
        } else {
            props.onListenValueChange(key, null);
        }
    };

    function Navigation() {
        return (
            <>
                {incidentStatus == "Draft" ? (
                <DraftFooter
                    mainSaveButton={props.mainSaveButton}
                    setIncidentStatus={props.setIncidentStatus}
                    setCheckStatus={props.setCheckStatus}
                    perms={props.AuthDetail.perms}
                    prevCategory={props.previousIncident.filtered_category}
                    customModalForConfirmCancel={props.customModalForConfirmCancel}
                    valueChanged={props.valueChanged}
                    showNotiPage={props.showNotiPage}
                    is_emergency_incident={props.overViewValues.is_emergency_incident}
                />
                ) : incidentStatus == "Pending Approval" ? (
                <PendingApprovalFooter
                    mainSaveButton={props.mainSaveButton}
                    setIncidentStatus={props.setIncidentStatus}
                    setCheckStatus={props.setCheckStatus}
                    perms={props.AuthDetail.perms}
                    prevCategory={props.previousIncident.filtered_category}
                    customModalForConfirmCancel={props.customModalForConfirmCancel}
                    valueChanged={props.valueChanged}
                    showNotiPage={props.showNotiPage}
                    authDetail={props.AuthDetail}
                    created_by={props.previousIncident.created_by}
                />
                ) : incidentStatus == "Approve" ? (
                <PendingRejectFooter
                    mainSaveButton={props.mainSaveButton}
                    setIncidentStatus={props.setIncidentStatus}
                    setCheckStatus={props.setCheckStatus}
                    perms={props.AuthDetail.perms}
                    prevCategory={props.previousIncident.filtered_category}
                    customModalForConfirmCancel={props.customModalForConfirmCancel}
                    valueChanged={props.valueChanged}
                    showNotiPage={props.showNotiPage}
                />
                ) : incidentStatus == "Closed" ? (
                <ReopenFooter
                    mainSaveButton={props.mainSaveButton}
                    setIncidentStatus={props.setIncidentStatus}
                    setCheckStatus={props.setCheckStatus}
                    perms={props.AuthDetail.perms}
                    prevCategory={props.previousIncident.filtered_category}
                    customModalForConfirmCancel={props.customModalForConfirmCancel}
                    valueChanged={props.valueChanged}
                    onListenValueChange={props.onListenValueChange}
                    showNotiPage={props.showNotiPage}
                />
                ) : incidentStatus == "Open" ? (
                <ClosedFooter
                    mainSaveButton={props.mainSaveButton}
                    setIncidentStatus={props.setIncidentStatus}
                    setCheckStatus={props.setCheckStatus}
                    perms={props.AuthDetail.perms}
                    prevCategory={props.previousIncident.filtered_category}
                    customModalForConfirmCancel={props.customModalForConfirmCancel}
                    valueChanged={props.valueChanged}
                    showNotiPage={props.showNotiPage}
                />
                ) : incidentStatus == "Archived" ? (
                <ReopenFooter
                    mainSaveButton={props.mainSaveButton}
                    setIncidentStatus={props.setIncidentStatus}
                    setCheckStatus={props.setCheckStatus}
                    perms={props.AuthDetail.perms}
                    prevCategory={props.previousIncident.filtered_category}
                    customModalForConfirmCancel={props.customModalForConfirmCancel}
                    valueChanged={props.valueChanged}
                    isArchived={true}
                    showNotiPage={props.showNotiPage}
                    onListenValueChange={props.onListenValueChange}
                    is_emergency_incident={props.overViewValues.is_emergency_incident}
                />
                ) : (
                <div
                    className="incident_footer"
                    style={{ bottom: 0, justifyContent: "flex-end" }}
                >
                    <div style={{ display: "flex" }}>
                    <div style={{ width: "100%" }} onClick={() => {}}>
                        <Button
                        className="witness_cancel_button"
                        onClick={() => {
                            history.goBack();
                        }}
                        >
                        Cancel
                        </Button>
                    </div>
                    </div>
                </div>
                )}
            </>
        );
    }

    function categoryInfoModel(onClose) {
        return (
            <div style={{ padding: 10 }}>
                <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                }}
                onClick={onClose}
                >
                <img src={ExitIcon} />
                </div>
                <div style={{ fontSize: 16, fontWeight: "bolder", marginBottom: 10 }}>
                Incident Category
                </div>
                {categoriesLevel.map((c, index) => {
                return (
                    <div
                    style={{
                        padding: 15,
                        border: "1px solid #D8D8D8",
                        borderRadius: 5,
                        marginBottom: 15,
                    }}
                    key={index}
                    >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                        style={{
                            background:
                            c.num == 1
                                ? "#EFFFF2"
                                : c.num == 2
                                ? "#FFF7CC"
                                : c.num == 3
                                ? "#FFD6B0"
                                : c.num == 4
                                ? "#FFB4B4"
                                : null,

                            color:
                            c.num == 1
                                ? "#42BE5C"
                                : c.num == 2
                                ? "#ECBB00"
                                : c.num == 3
                                ? "#FF8A62"
                                : c.num == 4
                                ? "#E85757"
                                : null,
                            border:
                            c.num == 1
                                ? "1px #42BE5C solid "
                                : c.num == 2
                                ? "1px #ECBB00 solid "
                                : c.num == 3
                                ? "1px #FF8A62 solid "
                                : c.num == 4
                                ? "1px #E85757 solid "
                                : null,
                            width: 40,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: " center",
                            alignItems: "center",
                            borderRadius: 8,
                            fontSize: 13,
                            fontWeight: "bold",
                            marginRight: 10,
                        }}
                        >
                        <div>CAT</div>
                        <div>{c.num}</div>
                        </div>
                        <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {c.subTitle}
                        </div>
                    </div>
                    <div
                        style={{
                        backgroundColor: "#D5D9CF",
                        margin: "10px 0px",
                        width: "100%",
                        height: 1,
                        }}
                    ></div>

                    <div style={{ marginBottom: 15, marginTop: 30 }}>
                        <div style={{ fontWeight: "bold", marginBottom: 3 }}>
                        Status
                        </div>
                        <div>{c.status}</div>
                    </div>
                    <div style={{ marginBottom: 15, marginTop: 30 }}>
                        <div style={{ fontWeight: "bold", marginBottom: 3 }}>
                        Impact
                        </div>
                        <div>{c.impact}</div>
                    </div>
                    <div style={{ marginBottom: 5, marginTop: 30 }}>
                        <div style={{ fontWeight: "bold", marginBottom: 3 }}>
                        Affected
                        </div>
                        <div>{c.affected}</div>
                    </div>
                    <div style={{ marginBottom: 5, marginTop: 30 }}>
                        <div style={{ fontWeight: "bold", marginBottom: 3 }}>
                        Reputation
                        </div>
                        <div>{c.reputation}</div>
                    </div>
                    </div>
                );
                })}
            </div>
        );
    }

    return (
        <div className="incident_overview_container">

            {/* Controllability Classification */}
            <h3 className={`dropdown_title ${ccError && "error"}`}>
                Controllability Classification{" "}
            </h3>
            <Dropdown
                search
                className={`dropdown-list  incident-list-dropdown ${ccError && "error"}`}
                style={{ paddingTop: 10 }}
                icon={
                    <img
                    src={ArrowDownDropDownIcon}
                    className="incident-place-list-icon"
                    />
                }
                fluid
                selection
                options={controllabilityClassification}
                value={values.controllability_classification}
                onChange={(e, data) => {
                    onChangeHSAction("controllability_classification", data.value);
                    // checkPreviousValueAndCurrent(
                    //     props.previousIncident.aar.root_cause.follow_up,
                    //     data.value,
                    //     "follow_up"
                    // );
                }}
                placeholder="Please Select..."
            />
            <div style={{ marginLeft: 3, fontSize: 13 }}>
                Note: C – Controllable, PC – Partial Controllable, BC – Beyond Control
            </div>
            {ccError && (
                <div style={{ color: "#E72D35", marginLeft: 3, fontSize: 13 }}>
                    Required field
                </div>
            )}

            {/* Controllability Sub-Classification */}
            <h3 className={`${cscError && "error"}`}>
                Controllability Sub-Classification{" "}
            </h3>
            <TextArea
                className={`remark_text_area ${cscError && "error"}`}
                placeholder="E.g. STF, Bitten/scratch by Macaw, Chased by Macaque etc."
                value={values.controllability_sub_classification}
                onChange={(e, data) => {
                    onChangeHSAction("controllability_sub_classification", data.value);
                    // checkPreviousValueAndCurrent(
                    //     props.previousIncident.aar.root_cause.follow_up,
                    //     data.value,
                    //     "follow_up"
                    // );
                }}
            />
            {cscError && (
                <div style={{ color: "#E72D35", marginLeft: 3, fontSize: 13 }}>
                    Required field
                </div>
            )}

            {/* Categorisation */}
            <div className="category_container">
                <div className="category_header">
                    <h3 className={`category_title ${categoryError && "error"}`}>
                        Category
                    </h3>

                    <Popup
                        trigger={
                            <img src={Category_Question} className="category_image" />
                        }
                        modal
                        closeOnDocumentClick={true}
                        className="category_info_model-container"
                        >
                        {(close) => {
                            return categoryInfoModel(close);
                        }}
                    </Popup>
                </div>
                <div className={`category_options ${categoryError && "error"}`}>
                    {categoryOptions.map((c) => {
                    return (
                        <div
                        className="c_option"
                        key={c.value}
                        onClick={() => {
                            props.onChangeIncidentOverView("category", c.value);
                            checkPreviousValueAndCurrent(
                                props.previousIncident.case_details.incident_description.category,
                                c.value,
                                "category"
                            );
                        }}
                        >
                        <img src={c.image} />

                        {overview_values.category === c.value ? (
                            <div className="c_circle">
                            <img src={CategoryChecked} />
                            </div>
                        ) : (
                            <div className="c_circle"></div>
                        )}
                        </div>
                    );
                    })}
                </div>
                {categoryError && (
                    <div style={{ color: "#E72D35", marginLeft: 3, fontSize: 13 }}>
                    Required field
                    </div>
                )}
            </div>

            {/* Type of Incident (for MOM) */}
            <h3 className={`dropdown_title ${typeOfIncidentMOMError && "error"}`}>
                Type of Incident (for MOM){" "}
            </h3>
            <Dropdown
                search
                className={`dropdown-list  incident-list-dropdown ${typeOfIncidentMOMError && "error"}`}
                style={{ paddingTop: 10 }}
                icon={
                    <img
                    src={ArrowDownDropDownIcon}
                    className="incident-place-list-icon"
                    />
                }
                fluid
                selection
                options={typeOfIncidentMOM}
                value={values.type_of_incident_for_mom}
                onChange={(e, data) => {
                    onChangeHSAction("type_of_incident_for_mom", data.value);
                    // checkPreviousValueAndCurrent(
                    //     props.previousIncident.case_details.incident_description.category,
                    //     c.value,
                    //     "category"
                    // );
                }}
                placeholder="Please Select..."
            />
            {typeOfIncidentMOMError && (
                <div style={{ color: "#E72D35", marginLeft: 3, fontSize: 13 }}>
                    Required field
                </div>
            )}
            
            {/* Footer */}
            {filterP4A &&
                props.previousIncident && 
                props.previousIncident.created_by == props.AuthDetail.id && (
                <>{Navigation()}</>
            )}
            {filterP4 &&
                props.previousIncident && <>{Navigation()}</>}

            {filterP5 &&
                props.previousIncident && <>{Navigation()}</>}
            {filterP5 &&
                props.previousIncident && <>{Navigation()}</>}
            {filterP5 &&
                props.previousIncident && <>{Navigation()}</>}

            <div className="incident_footer"
                style={{ bottom: 0, justifyContent: "flex-end", zIndex: 1 }}>
                <div style={{ display: "flex" }}>
                    <div style={{ width: "100%" }} onClick={() => {}}>
                        <Button
                        className="witness_cancel_button"
                        onClick={() => {
                            history.goBack();
                        }}
                        >
                        Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HS;